import { ThemeOptions } from '@mui/material'

// Blue
const PaletteBlue = {
  p5: '#E2F2FE',
  p10: '#B9DDFC',
  p20: '#8DC9FB',
  p30: '#5DB3F9',
  p40: '#36A3F9',
  p50: '#0093F7',
  p60: '#0085E9',
  p70: '#0073D6',
  p80: '#0062C4',
  p90: '#0044A5',
  pA10: '#BCE1FF',
  pA20: '#8FCEFF',
  pA40: '#31AAFF',
  pA70: '#2977FF',
}

// Red
const PaletteRed = {
  p5: '#FEEBEE',
  p10: '#FECDD2',
  p20: '#EF9A9A',
  p30: '#E57373',
  p40: '#EF5350',
  p50: '#F44336',
  p60: '#E53935',
  p70: '#D32F2F',
  p80: '#C62828',
  p90: '#B71C1C',
  pA10: '#FF8A80',
  pA20: '#FF5252',
  pA40: '#FF1744',
  pA70: '#D50000',
}

// Green
const PaletteGreen = {
  p5: '#E8F5E9',
  p10: '#C8E6C9',
  p20: '#A5D6A7',
  p30: '#81C784',
  p40: '#66BB6A',
  p50: '#4CAF50',
  p60: '#43A047',
  p70: '#388E3C',
  p80: '#2E7D32',
  p90: '#1B5E20',
  pA10: '#B9F6CA',
  pA20: '#69F0AE',
  pA40: '#00E676',
  pA70: '#00C853',
}

// Yellow
const PaletteYellow = {
  p5: '#FFFDE7',
  p10: '#FFF9C4',
  p20: '#FFF59D',
  p30: '#FFF176',
  p40: '#FFEE58',
  p50: '#FFEB3B',
  p60: '#FDD835',
  p70: '#FBC02D',
  p80: '#F9A825',
  p90: '#F57F17',
  pA10: '#FFFF8D',
  pA20: '#FFFF00',
  pA40: '#FFEA00',
  pA70: '#FFD600',
}

// Cyan
const PaletteCyan = {
  p5: '#E0F7FA',
  p10: '#B2EBF2',
  p20: '#80DEEA',
  p30: '#4DD0E1',
  p40: '#26C6DA',
  p50: '#00BCD4',
  p60: '#00ACC1',
  p70: '#0097A7',
  p80: '#00838F',
  p90: '#006064',
  pA10: '#84FFFF',
  pA20: '#18FFFF',
  pA40: '#00E5FF',
  pA70: '#00B8D4',
}

// Grey
const PaletteGrey = {
  p0: '#FFFFFF',
  p5: '#F8F8F8',
  p10: '#F0F0F0',
  p20: '#E5E5E5',
  p30: '#D4D4D4',
  p40: '#AFAFAF',
  p50: '#8F8F8F',
  p60: '#676767',
  p70: '#545454',
  p80: '#363636',
  p90: '#161616',
  p100: '#F0F0F0',
  pA10: '#E5E5E5',
  pA20: '#18FFFF',
  pA40: '#AFAFAF',
  pA70: '#545454',
}

// State Palettes
const PaletteDefault = {
  ...PaletteGrey,
}

const PalettePrimary = {
  ...PaletteBlue,
}

const PaletteSecondary = {
  ...PaletteGrey,
}

const PaletteError = {
  ...PaletteRed,
}

const PaletteSuccess = {
  ...PaletteGreen,
}

const PaletteWarning = {
  ...PaletteYellow,
}

const PaletteInfo = {
  ...PaletteCyan,
}
let themeConfig: ThemeOptions = {}

themeConfig = {
  palette: {
    mode: 'light',
    common: {
      black: PaletteGrey.p100,
      white: PaletteGrey.p0,
    },
    primary: {
      main: PalettePrimary.p80,
      light: PalettePrimary.p70,
      dark: PalettePrimary.p90,
    },
    secondary: {
      main: PaletteSecondary.p80,
      light: PaletteSecondary.p70,
      dark: PaletteSecondary.p90,
    },
    info: {
      main: PaletteInfo.p80,
      light: PaletteInfo.p50,
      dark: PaletteInfo.p90,
    },
    success: {
      main: PaletteSuccess.p80,
      light: PaletteSuccess.p50,
      dark: PaletteSuccess.p90,
    },
    error: {
      main: PaletteError.p70,
      light: PaletteError.p60,
      dark: PaletteError.p80,
    },
    warning: {
      main: PaletteWarning.p80,
      light: PaletteWarning.p50,
      dark: PaletteWarning.p90,
    },
    text: {
      primary: PaletteDefault.p90,
      secondary: PaletteDefault.p70,
      disabled: PaletteDefault.p50,
    },
    background: {
      default: PaletteGrey.p5,
      paper: PaletteGrey.p0,
    },
    // TODO Add ClearWater Accent Colors
  },
  components: {
    // TODO add more components to override style
    MuiMenu: {
      defaultProps: {
        elevation: 3,
        anchorOrigin: {
          vertical: 'bottom',
          horizontal: 'left',
        },
        transformOrigin: {
          vertical: 'top',
          horizontal: 'left',
        },
      },
      styleOverrides: {
        paper: {
          borderRadius: 4,
        },
      },
    },
    MuiMenuList: {},
    MuiMenuItem: {
      styleOverrides: {
        root: {
          borderRadius: 0,
          gap: 8,
        },
      },
    },
    MuiButtonBase: {
      styleOverrides: {
        root: {
          borderRadius: 4,
          fontFamily: '"Source Sans 3", sans-serif',
          fontSize: 16,
          fontWeight: 600,
          textTransform: 'none', //remove default all-caps transform
        },
      },
    },
    MuiTabs: {
      styleOverrides: {
        root: {
          minHeight: '2rem',
        },
      },
    },
    MuiTab: {
      styleOverrides: {
        root: {
          minHeight: '2rem',
          paddingTop: 0,
          paddingBottom: 0,
        },
      },
    },
    MuiIconButton: {
      variants: [
        {
          props: { size: 'small' },
          style: {
            fontSize: '1rem',
          },
        },
        {
          props: { size: 'medium' },
          style: {
            fontSize: '1.5rem',
          },
        },
      ],
    },
    MuiButton: {
      variants: [
        {
          props: { size: 'small' },
          style: {
            fontSize: '1rem',
            fontWeight: 500,
          },
        },
      ],
    },
    MuiListItemIcon: {
      styleOverrides: {
        root: {
          color: 'rgba(0,0,0,1)',
          minWidth: 36,
          fontSize: '0.4rem',
          textAlign: 'center',
          justifyContent: 'center',
        },
      },
    },
    MuiListItemText: {
      styleOverrides: {
        root: {
          margin: 0,
        },
      },
    },
    MuiSwitch: {
      styleOverrides: {
        track: {
          opacity: 0.5,
          backgroundColor: PaletteGrey.p50,
        },
      },
    },
    MuiCardHeader: {
      styleOverrides: {
        action: {
          alignSelf: 'center',
        },
      },
    },
    MuiAccordion: {
      styleOverrides: {
        root: {
          marginBottom: '1rem',
          boxSizing: 'border-box',
          minHeight: 0,

          '&.Mui-expanded': {
            marginBottom: '1rem',
          },
        },
      },
    },
    MuiAccordionSummary: {
      styleOverrides: {
        root: {
          flexDirection: 'row-reverse',
          backgroundColor: PaletteGrey.p5,
          borderBottom: `1px solid ${PaletteGrey.p30}`,
          minHeight: '4rem',
          margin: 0,
          borderRadius: '0.25rem',
          boxSizing: 'border-box',

          '&.Mui-expanded': {
            minHeight: '4rem',
            margin: 0,
            boxSizing: 'border-box',
            borderRadius: `${1} ${1} 0 0`,
          },
        },
        content: {
          minHeight: '4rem',
          margin: 0,
          boxSizing: 'border-box',

          '&.Mui-expanded': {
            minHeight: '4rem',
            margin: 0,
            boxSizing: 'border-box',
          },
        },
      },
    },
    MuiAccordionDetails: {
      styleOverrides: {
        root: {
          padding: 8,
        },
      },
    },
  },

  typography: {
    fontFamily: '"Source Sans 3", sans-serif',
    htmlFontSize: 16,
    fontSize: 16,
    fontWeightBold: 700,
    fontWeightMedium: 500,
    fontWeightRegular: 400,
    fontWeightLight: 300,
    button: {
      textTransform: 'none', //remove default all-caps transform
    },
    // the largest style size in the font ramp, used for page layouts.
    // Ex: Application header, aka Helios, Prism etc
    h1: {
      fontSize: 24,
      fontWeight: 900,
      lineHeight: 30 / 24, // 1.25
    },
    // Containers level 1
    // Ex: Helios Panel Headers
    h2: {
      fontSize: 24,
      fontWeight: 700,
      lineHeight: 30 / 24, // 1.25
    },
    // Subheaders
    // Ex:
    h3: {
      fontSize: 20,
      fontWeight: 700,
      lineHeight: 30 / 20, // 1.5
    },
    // Contained in h3
    // Ex: Side Panels, Widgets, Cards, Modals, Popover
    h4: {
      fontSize: 20,
      fontWeight: 600,
      lineHeight: 30 / 20, // 1.5
    },
    // Sub header contained within h4
    // Ex:
    h5: {
      fontSize: 16,
      fontWeight: 600,
      lineHeight: 24 / 16, // 1.5
    },
    // Tabs, Alerts, Notification Headers
    h6: {
      fontSize: 12,
      fontWeight: 700,
      lineHeight: 18 / 12, // 1.5
    },
    // SubTitles
    // Subtitle 1: Subtitles might be used directly under a Header 1 or Header 2
    subtitle1: {
      fontSize: 20,
      fontWeight: 400,
      lineHeight: 30 / 20, // 1.5
    },
    // Subtitle 2: Smaller subtitle, sometimes used under header text or to section content.
    subtitle2: {
      fontSize: 16,
      fontWeight: 600,
      lineHeight: 24 / 16, // 1.5
    },
    // Body Text
    // Default body text size. Should be used for most body text., alert
    body1: {
      fontSize: 16,
      fontWeight: 400,
      lineHeight: 24 / 16, // 1.5
    },
    // Smaller body text. Recommended for high-density components and layouts.
    body2: {
      fontSize: 14,
      fontWeight: 400,
      lineHeight: 21 / 14, // 1.5
    },
  },
  shape: {
    borderRadius: 4,
  },
  spacing: 4,
}

export const SEMANTIC_COLOR_PALETTE = {
  success: '#2E7D32',
  border: {
    dark: '#8F8F8F',
    light: '#E5E5E5',
  },
}

export default themeConfig
